"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchFilterOptions = exports.formatToCloudSearchFilterOption = exports.getDomainObjectFilterOption = void 0;
var document_types_1 = require("./document-types");
var LogicOperator;
(function (LogicOperator) {
    LogicOperator["AND"] = "AND";
    LogicOperator["OR"] = "OR";
    LogicOperator["NOT"] = "NOT";
})(LogicOperator || (LogicOperator = {}));
function getDomainObjectFilterOption(searchFilterOption) {
    return {
        objectType: 'file',
        filter: {
            compositeFilter: {
                logicOperator: LogicOperator.AND,
                subFilters: [
                    {
                        valueFilter: {
                            operatorName: 'objectreftypes',
                            value: {
                                stringValue: searchFilterOption.type,
                            },
                        },
                    },
                    {
                        valueFilter: {
                            operatorName: 'objectrefids',
                            value: {
                                stringValue: searchFilterOption.id,
                            },
                        },
                    },
                ],
            },
        },
    };
}
exports.getDomainObjectFilterOption = getDomainObjectFilterOption;
function getProducerFilterOption(userUuid) {
    return {
        objectType: 'file',
        filter: {
            valueFilter: {
                operatorName: 'relatedusers',
                value: {
                    stringValue: userUuid,
                },
            },
        },
    };
}
function getFileStatusFilterOption(status) {
    return {
        objectType: 'file',
        filter: {
            valueFilter: {
                operatorName: 'filestatus',
                value: {
                    stringValue: status,
                },
            },
        },
    };
}
function getDocumentTypeFilterOption(documentTypes) {
    var documentTypeFilterOptions = documentTypes.map(function (documentTypeKey) {
        return {
            valueFilter: {
                operatorName: 'category',
                value: {
                    stringValue: (0, document_types_1.getDocumentTypeByKey)(documentTypeKey),
                },
            },
        };
    });
    return {
        objectType: 'file',
        filter: {
            compositeFilter: {
                logicOperator: LogicOperator.OR,
                subFilters: __spreadArray([], documentTypeFilterOptions, true),
            },
        },
    };
}
function formatToCloudSearchFilterOption(domainObjectReference) {
    if (!domainObjectReference)
        return;
    return Object.entries(domainObjectReference).flatMap(function (_a) {
        var domainObjectType = _a[0], identifiers = _a[1];
        var type = domainObjectType;
        var ids = identifiers;
        return type ? ids.map(function (id) { return ({ type: type, id: id }); }) : [];
    });
}
exports.formatToCloudSearchFilterOption = formatToCloudSearchFilterOption;
function getSearchFilterOptions(options) {
    var cloudSearchFilterOptions = options.cloudSearchFilterOptions, isProducer = options.isProducer, userUuid = options.userUuid, fileStatus = options.fileStatus, documentTypes = options.documentTypes;
    var filterOptions = [];
    // do we have a VALID filter options.
    if (cloudSearchFilterOptions === null || cloudSearchFilterOptions === void 0 ? void 0 : cloudSearchFilterOptions.length) {
        cloudSearchFilterOptions === null || cloudSearchFilterOptions === void 0 ? void 0 : cloudSearchFilterOptions.forEach(function (domainObjectFilterOption) {
            filterOptions.push(getDomainObjectFilterOption(domainObjectFilterOption));
        });
    }
    if (isProducer) {
        filterOptions.push(getProducerFilterOption(userUuid));
    }
    if (fileStatus) {
        filterOptions.push(getFileStatusFilterOption(fileStatus));
    }
    if (documentTypes && documentTypes.length > 0) {
        filterOptions.push(getDocumentTypeFilterOption(documentTypes));
    }
    return filterOptions;
}
exports.getSearchFilterOptions = getSearchFilterOptions;
